import { createApp } from 'vue';
import speedTest from './speed-test';
import './speed-test.css';
import SpeedTest from './speed-test.vue';

export default createApp({
  components: {
    SpeedTest,
  },
  mounted() {
    speedTest();
  },
}).mount('#speed-test');
